package org.example.zone360.models

import kotlinx.serialization.Serializable


@Serializable
data class CreateClubResponse(
    val data: CreateClubData? = null,
    val error: String? = null
)

@Serializable
data class CreateClubData(
    val clubName: String,
    val email: String,
    val firstName: String,
    val id: String,
    val lastName: String,
    val organization: String,
    val role: String,
    val type: String,
    val uid: String,
)